import styled from 'styled-components';

export const Control = styled.div`
  display: flex;
  width: 100%;
  padding-right: 1rem;
  button:first-of-type{
    border-radius: 0;
  }
  button:last-of-type{
    border-radius: 0 10px 10px 0;
  }
`;
